/**
 * Forces all PDF links to download automatically, if the browser supports it.  
 * Otherwise, open the link in a new browser window or tab.
 */
function custmatchHeight() {
//   $.fn.matchHeight._maintainScroll = true;
  /*jQuery('#shopify-section-static-collection .collection-grid-item').matchHeight({
    byRow: true
  });*/
  /*jQuery('#shopify-section-static-collection .collection-grid-item .product-item-title').matchHeight({
    byRow: true
  });*/
  /*jQuery('#shopify-section-static-collection .collection-grid-item .product-item-image').matchHeight({
    byRow: true
  });*/
  /*$.fn.matchHeight._maintainScroll = true;
  $.fn.matchHeight._update();*/
}

jQuery(window).scroll(function () {
//   custmatchHeight();
  if ( $(this).scrollTop() > 20 && !$('body').hasClass('body-sticky') ) {    
    jQuery('body').addClass('body-sticky');
  } else if ( $(this).scrollTop() <= 20 ) {
    jQuery('body').removeClass('body-sticky');
  }
});

jQuery(document).ready(function($) {
  $('body').on('click','.download-menu-pdf', function(e){
    	e.preventDefault();
        download($('.download-menu-pdf').attr('href'));
  }); 
  setTimeout(function(){
    custmatchHeight();  
  }, 2000);  
  $('.product-menu-slideout-button-dimiss').click(function(){
    $('.product-atc-failure-message').css('display','none');
    $('.custom-failure').css('display','none');
  });
  
  //Show search bar on mobile.
  $('body').on('click','.mobilenav-toggle-search', function(e){    
    $('.bc-sf-search-suggestion-mobile-top-panel').css('display','block');
  });   
  
  jQuery('.product-item-image').matchHeight({
    byRow: true
  });
});

jQuery(window).resize(function(){
  custmatchHeight();
});
/*jQuery('#shopify-section-static-collection').imagesLoaded( function() {
  console.log('imagesLoaded111');
  jQuery('#shopify-section-static-collection .collection-grid-item').matchHeight({
    byRow: true
  });
  $.fn.matchHeight._maintainScroll = true;
  $.fn.matchHeight._update();  
});*/
/*$(document).ajaxSuccess(function(){
  setTimeout(function(){
  	custmatchHeight();
  }, 3000);  
});*/
$( document ).ajaxComplete(function() {
  setTimeout(function(){
    custmatchHeight();
  }, 3000);  
});

//video-slider

$('#main-slider').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: false,
      infinite: true,
      adaptiveHeight: true,
      arrows: true,
  	  adaptiveHeight: false
  });

$('.customer-review').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: true,
      infinite: true,
  	  autoplay: true,
      autoplaySpeed: 5000,
      arrows: false
  });
  
if($('#main-slider .slick-active').length > 0){
  var video = $('#main-slider .slick-active').find('iframe').get(0).play();
  $('#main-slider').on('afterChange', function(event, slick, currentSlide, nextSlide){
    $('#main-slider .slick-slide').find('video').get(0).pause();
    var video = $('#main-slider .slick-active').find('video').get(0).play();
  });
}


